import type { InvoiceStatus } from '@lira/shared';

export interface StatusMeta {
  label: string;
  /** classes de cor do badge (texto + fundo suave). */
  cls: string;
}

/** Rótulo + cor do status da fatura (motor puro). */
export const STATUS_META: Record<InvoiceStatus, StatusMeta> = {
  open: { label: 'Fatura aberta', cls: 'bg-cards/10 text-cards' },
  closed: { label: 'Fatura fechada', cls: 'bg-canvas text-ink' },
  overdue: { label: 'Fatura vencida', cls: 'bg-alert/10 text-alert' },
  paid: { label: 'Fatura paga', cls: 'bg-income-weak text-income' },
  partial: { label: 'Parcialmente paga', cls: 'bg-alert/10 text-alert' },
};
